var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBoiteW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.21 35.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_358",
    "data-name": "Groupe 358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_315",
    "data-name": "Groupe 315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_312",
    "data-name": "Groupe 312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3962",
    "data-name": "Trac\\xE9 3962",
    d: "M28.6,13.75a.55.55,0,0,1-.55-.55h0V8.25H7.16V13.2a.56.56,0,0,1-1.11,0V7.7a.55.55,0,0,1,.55-.55h22a.56.56,0,0,1,.56.55h0v5.5A.56.56,0,0,1,28.6,13.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_313",
    "data-name": "Groupe 313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3963",
    "data-name": "Trac\\xE9 3963",
    d: "M27,6.05a.55.55,0,0,1-.55-.55h0V4.4H8.8V5.5a.55.55,0,0,1-.55.55A.55.55,0,0,1,7.7,5.5V3.85a.55.55,0,0,1,.55-.55H27a.55.55,0,0,1,.55.55h0V5.5A.55.55,0,0,1,27,6.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_314",
    "data-name": "Groupe 314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3964",
    "data-name": "Trac\\xE9 3964",
    d: "M24.76,2.2a.56.56,0,0,1-.56-.55h0V1.1H11v.55a.56.56,0,0,1-1.11,0V.55A.55.55,0,0,1,10.45,0H24.76a.55.55,0,0,1,.55.55h0v1.1a.55.55,0,0,1-.55.55Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_320",
    "data-name": "Groupe 320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_316",
    "data-name": "Groupe 316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3965",
    "data-name": "Trac\\xE9 3965",
    d: "M33.56,35.21H1.65A1.66,1.66,0,0,1,0,33.56V16a.68.68,0,0,1,0-.14L2.77,5.36a.55.55,0,1,1,1.06.28h0L1.1,16V33.55a.55.55,0,0,0,.55.55H33.56a.55.55,0,0,0,.55-.55V16L31.37,5.64a.56.56,0,0,1,.4-.67.55.55,0,0,1,.67.39h0l2.75,10.45a.78.78,0,0,1,0,.14v17.6A1.65,1.65,0,0,1,33.56,35.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_318",
    "data-name": "Groupe 318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_317",
    "data-name": "Groupe 317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3966",
    "data-name": "Trac\\xE9 3966",
    d: "M21.69,18.7H13.51a1.64,1.64,0,0,1-1.6-1.25l-.13-.53a.55.55,0,0,0-.54-.42H5A.54.54,0,0,1,4.41,16,.55.55,0,0,1,5,15.4h6.29a1.65,1.65,0,0,1,1.6,1.25l.14.54a.55.55,0,0,0,.53.41h8.18a.55.55,0,0,0,.54-.41l.13-.54A1.65,1.65,0,0,1,24,15.4h10.7a.55.55,0,0,1,.54.56.54.54,0,0,1-.54.54H24a.54.54,0,0,0-.53.42l-.13.53A1.66,1.66,0,0,1,21.69,18.7Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_319",
    "data-name": "Groupe 319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3967",
    "data-name": "Trac\\xE9 3967",
    d: "M22.55,29.7h-9.9a.55.55,0,0,1-.55-.54h0v-6a.55.55,0,0,1,.55-.55h9.9a.55.55,0,0,1,.55.55h0v6a.54.54,0,0,1-.55.55ZM13.2,28.6H22v-5H13.2Z",
    style: {
      fill: "#fff"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBoiteW);
export default __webpack_public_path__ + "static/media/ic-boite-w.4913ae9fb817a6d6fa823ef0a407629a.svg";
export { ForwardRef as ReactComponent };